<template>
    <div class="well ovx-auto">
        <div class="flex-level">
            <div class="flex fs-4 bold">
                {{ $l10n.__('Produits ponctuels et coûts internes') }}
            </div>
            <div class="flex aright">
                <CompassButton
                    :label="$t.__('common.actions.impact_profit')"
                    type="secondary"
                    :disabled="impactButtonIsDisable"
                    @click="impact()"
                />
                <CompassButton
                    :label="$t.__('documents.overview.tab.margin.Custom.add_entry')"
                    type="secondary"
                    :disabled="!canImpact"
                    @click="displayPopup = true"
                />
            </div>
        </div>

        <el-table
            ref="multipleTable"
            class="table-margin"
            :data="customs"
            columnKey="id"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" :selectable="canProcess" property="processMargin">
            </el-table-column>
            <el-table-column :label="$t.__('common.labels.impact_profit')">
                <template #default="scope">
                    {{ displaySaasBoolean(scope.row.processMargin) }}
                </template>
            </el-table-column>
            <el-table-column
                property="label"
                :label="$t.__('documents.overview.tab.margin.descirption')"
            >
            </el-table-column>
            <el-table-column
                :label="$t.__('documents.overview.tab.margin.unit_purchase_amount_exclude_tax')"
            >
                <template #default="scope">
                    {{
                        $filters.numberFormatWithOptions(
                            scope.row.unitAmount,
                            unitNumberFormat,
                            true,
                        )
                    }}
                </template>
            </el-table-column>
            <el-table-column :label="$t.__('common.labels.quantity')">
                <template #default="scope">
                    {{ $filters.numberFormat(scope.row.qt) }}
                </template>
            </el-table-column>
            <el-table-column
                :label="
                    $t.__('documents.overview.tab.margin.Custom.total_purchase_amount_exclude_tax')
                "
            >
                <template #default="scope">
                    {{
                        $filters.numberFormatWithOptions(
                            scope.row.totalAmount,
                            docNumberFormat,
                            true,
                        )
                    }}
                </template>
            </el-table-column>
            <el-table-column v-if="canImpact" fixed="right">
                <template #default="scope">
                    <context-menu
                        @unlink="removeLink(scope.row, context, scope.row)"
                        @update="edit(scope.row)"
                    />
                </template>
            </el-table-column>
        </el-table>

        <div v-if="customs.length > 0" class="aright fs-3 mt-2">
            {{ $l10n.__('Total impact') }} :
            {{ $filters.numberFormatWithOptions(formattedTotal, docNumberFormat, true) }}
        </div>

        <link-custom-entry-form
            v-if="displayPopup"
            :custom="margeToEdit"
            @close="closePopup"
            @custom-entry-added="refreshAfterAdd"
        >
        </link-custom-entry-form>
    </div>
</template>

<script>
import MarginMixins from './MarginMixins.js';
import LinkCustomEntryForm from './LinkCustomEntryForm.vue';
import ContextMenu from './ContextMenu.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('documentOverview');

export default {
    mixins: [MarginMixins],
    data() {
        return {
            displayPopup: false,
            context: 'custom',
            margeToEdit: {},
        };
    },
    computed: {
        ...mapState({
            customs: (state) => state.customs,
            original: (state) => state.customs.filter((link) => link.processMargin === true),
        }),
    },
    methods: {
        refreshAfterAdd: function () {
            this.checkRows();
            this.$emit('update');
        },
        closePopup: function () {
            this.displayPopup = false;
            this.margeToEdit = {};
        },
        edit: function (marge) {
            this.margeToEdit = marge;
            this.displayPopup = true;
        },
        removeLink: function (link, context) {
            this.deleteLink({
                id: link.linkedId,
                context: context,
            }).then(() => {
                Push.success(this.$l10n.__('Ressource déliée'));
                if (link.processMargin) {
                    this.impact(true);
                }
            });
        },
    },
    components: {
        LinkCustomEntryForm,
        ContextMenu,
    },
};
</script>
